import { render } from "./CommissionsSelector.vue?vue&type=template&id=640605a4&ts=true"
import script from "./CommissionsSelector.vue?vue&type=script&lang=ts"
export * from "./CommissionsSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
